import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../layouts/PageLayout';

const BENEFITS = [
  {
    icon: 'bi bi-geo-alt',
    title: 'Local & Reliable',
    desc: 'As a Kelowna-based company, we take pride in serving our community with dependable and friendly service.',
  },
  {
    icon: 'bi bi-tools',
    title: 'Advanced Equipment',
    desc: 'We use powerful, professional-grade equipment to remove dust, debris, and allergens from your duct system.',
  },
  {
    icon: 'bi bi-award',
    title: 'Certified Technicians',
    desc: 'Our trained and certified technicians follow industry standards to ensure safe and effective duct and dryer vent cleaning services.',
  },
  {
    icon: 'bi bi-cash-stack',
    title: 'Transparent Pricing',
    desc: 'No hidden fees. We provide clear and honest pricing before starting any work.',
  },
  {
    icon: 'bi bi-building',
    title: 'Wide Service Coverage',
    desc: 'We serve both commercial as well as residential properties including condos, townhouses, duplexes, detached homes, and more.',
  },
  {
    icon: 'bi bi-heart',
    title: 'Prioritizing Customer Satisfaction',
    desc: 'Customer satisfaction is at the heart of everything we do. We focus on quality work, clear communication, and dependable service on every job.',
  },
];

function WhyUs() {
  return (
    <>
      <div className="page-content">
        <PageLayout
          pageTitle="Why Us"
          desc="Reasons to choose Kelowna Duct Cleaning for your duct and dryer vent cleaning needs."
        />

        <section className="content-inner bg-light icon-section section-wrapper2">
          <div className="container">
            <div className="section-head text-center m-b50">
              <h2 className="title">Benefits of Choosing Us</h2>
              <p className="m-0">
                Professional duct cleaning, clear communication, and service you can rely on.
              </p>
            </div>
            <div className="row sp60">
              {BENEFITS.map((item, ind) => (
                <div className="col-xl-4 col-md-6 m-b60" key={ind}>
                  <div className="icon-bx-wraper style-3 text-center">
                    <div className="icon-content">
                      <div className="icon-media m-b20">
                        <i
                          className={item.icon}
                          style={{ fontSize: '2.5rem', color: 'white' }}
                        />
                      </div>
                      <h4 className="title">{item.title}</h4>
                      <p className="m-b0">{item.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center m-t40">
              <Link to="/contact-us" className="btn btn-primary btn-lg">
                Get a Quote
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default WhyUs;
